import { useMemo, useState } from 'react';

import { useParams } from 'react-router';

import { useQuery } from '@tanstack/react-query';

import { useRequestListagem } from 'hooks/useRequestListagem';
import { ConfigPedidoProps } from 'pages/compra/pedido/types';

export function useRefazerQuebras() {
    const requestListagem = useRequestListagem();
    const { id } = useParams();

    return useQuery<ConfigPedidoProps>({
        queryKey: ['config-pedido-refazer-quebras', id],
        queryFn: () =>
            requestListagem({
                url: `/gestao/configpedido/${id}`,
            }).then((res) => res.data.data),
        enabled: false,
    });
}
